import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {FormattedMessage} from "react-intl";

class Loading extends React.Component {
    render() {
        if (this.props.main && this.props.main === true) {
            return (
                <div className={`main-content ${this.props.mainClassName}`}>
                    <div className={'text-center p-3'}><p><FormattedMessage id={'app.loading'}/></p><FontAwesomeIcon icon={['far', 'spinner']} spin/></div>
                </div>
            )
        }

        return (<div className={'text-center p-3'}><p><FormattedMessage id={'app.loading'}/></p><FontAwesomeIcon icon={['far', 'spinner']} spin/></div>);
    }
}

export default Loading;
